<div class="row" *ngIf="isComercial || isBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Total de espigas avaliadas do retorno</mat-label>
                                <input matInput id="txtTotal_espigas_avaliadas_retorno"
                                    #txtTotal_espigas_avaliadas_retorno maxlength="10"
                                    formControlName="Total_espigas_avaliadas_retorno" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtTotal_espigas_avaliadas_retorno.value.length}} / 10
                                </mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Total_espigas_avaliadas_retorno)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Número de espigas despalhadas no retorno</mat-label>
                                <input matInput id="txtNum_espigas_despalhadas_retorno"
                                    #txtNum_espigas_despalhadas_retorno maxlength="3"
                                    formControlName="Num_espigas_despalhadas_retorno" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtNum_espigas_despalhadas_retorno.value.length}} / 3
                                </mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Num_espigas_despalhadas_retorno)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Total de espigas avaliadas na mesa</mat-label>
                                <input matInput id="txtTotal_espigas_avaliadas_mesa" #txtTotal_espigas_avaliadas_mesa
                                    maxlength="10" formControlName="Total_espigas_avaliadas_mesa" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtTotal_espigas_avaliadas_mesa.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Total_espigas_avaliadas_mesa)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Número de espigas com palha na mesa</mat-label>
                                <input matInput id="txtNum_espigas_palha_mesa" #txtNum_espigas_palha_mesa maxlength="3"
                                    formControlName="Num_espigas_palha_mesa" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtNum_espigas_palha_mesa.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Num_espigas_palha_mesa)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor"> Espigas despalhadas no retorno (%)
                                </mat-label>
                                <input matInput id="txtEspigas_despalhadas_retorno" #txtEspigas_despalhadas_retorno
                                    maxlength="10" formControlName="Espigas_despalhadas_retorno" readonly currencyMask
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtEspigas_despalhadas_retorno.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Espigas_despalhadas_retorno)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor"> Espigas com palha na mesa de seleção (%)
                                </mat-label>
                                <input matInput id="txtEspigas_palha_mesa" #txtEspigas_palha_mesa maxlength="10"
                                    formControlName="Espigas_palha_mesa" readonly currencyMask class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtEspigas_palha_mesa.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Espigas_palha_mesa)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>

<div class="row" *ngIf="isPreBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Seleção Horas
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtSelecaoHoras" #txtSelecaoHoras maxlength="5"
                                    [dropSpecialCharacters]="false" formControlName="selecao_horas" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" readonly
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtSelecaoHoras.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.selecao_horas)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Debulha Horas
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtDebulhaHoras" #txtDebulhaHoras maxlength="5"
                                    [dropSpecialCharacters]="false" formControlName="debulhas_horas" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" readonly
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtDebulhaHoras.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.debulhas_horas)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tempo de atraso (secagem - seleção)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtAtrasoSecagem" #txtAtrasoSecagem maxlength="5"
                                    [dropSpecialCharacters]="false" formControlName="tempo_atraso_secagem" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" readonly
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtAtrasoSecagem.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.tempo_atraso_secagem)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tempo de atraso (seleção - debulha)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtAtrasoDebulha" #txtAtrasoDebulha maxlength="5"
                                    [dropSpecialCharacters]="false" formControlName="tempo_atraso_selecao" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" readonly
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtAtrasoDebulha.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.tempo_atraso_selecao)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tempo de parada seleção
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtParadaSelecao" #txtParadaSelecao maxlength="5"
                                    [dropSpecialCharacters]="true" formControlName="tempo_parada_selecao" readonly
                                    class="InputBlockColor" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtParadaSelecao.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.tempo_parada_selecao)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tempo de parada debulha
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtParadaDebulha" #txtParadaDebulha maxlength="5"
                                    [dropSpecialCharacters]="true" formControlName="tempo_parada_debulha" readonly
                                    class="InputBlockColor" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtParadaDebulha.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.tempo_parada_debulha)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>